<template>
  <div class="field image-field">
    <div class="control" :class="{ 'is-loading': loading }">
      <meal-image class="image is-16by9" :src="mealImageUrl" />
      <div class="image-actions buttons">
        <a
          class="button"
          @click="openImageEditor"
          v-if="mealImageUrl && editMode"
        >
          <span><i class="fa fa-edit"/></span>
          <span class="button-label is-hidden-touch">{{ $t("Edit") }}</span>
        </a>
        <a
          :href="mealImageUrl"
          target="_blank"
          v-if="mealImageUrl"
          class="button"
        >
          <span><i class="fa fa-save"/></span>
          <span class="button-label is-hidden-touch">{{ $t("Download") }}</span>
        </a>
        <label v-if="editMode" class="file-label button">
          <input
            class="file-input"
            type="file"
            name="resume"
            :accept="accept"
            @change.prevent="onUpload"
            :disabled="loading"
          />
          <span><i class="fa fa-upload"/></span>
          <span class="button-label is-hidden-touch">{{ $t("Upload") }}</span>
        </label>
      </div>
      <p class="help is-danger">{{ $t(errors && errors[0]) }}</p>
    </div>
    <image-editor
      v-if="isEditorOpen"
      :imageTitle="imageTitle"
      :mealOriginUrl="mealOriginUrl"
      :cropData="cropData"
      @submit="submitImageChanges"
      @close="closeImageEditor"
    />
  </div>
</template>

<script>
import MealImage from "@/components/meal-image"
import ImageEditor from "./image-editor"

export default {
  name: "image-field",
  props: [
    "errors",
    "loading",
    "accept",
    "mealImageUrl",
    "mealOriginUrl",
    "editMode",
    "imageTitle",
    "cropData"
  ],
  components: {
    MealImage,
    ImageEditor
  },
  data() {
    return {
      isEditorOpen: false
    }
  },
  methods: {
    onUpload(e) {
      const files = e.target.files
      const file = files[0]
      if (file == null) {
        this.$emit("upload")
        return
      }
      file.imageRef = this.fileUniqueName(file)
      this.$emit("upload", file)
    },
    fileUniqueName(file) {
      let imageRef = Date.now() + ""
      const dotPos = file.name.lastIndexOf(".")
      if (dotPos > 0) {
        imageRef =
          file.name.substring(0, dotPos + 1) +
          imageRef +
          file.name.substring(dotPos)
      }
      return imageRef
    },
    openImageEditor() {
      this.isEditorOpen = true
      document.documentElement.classList.add("is-clipped")
    },
    closeImageEditor() {
      this.isEditorOpen = false
      document.documentElement.classList.remove("is-clipped")
    },
    submitImageChanges(e) {
      const cropData = e.target.editOperations
      this.$emit("change", cropData)
      this.closeImageEditor()
    }
  }
}
</script>

<style lang="scss" scoped>
.image-field {
  .file-input {
    display: none;
  }
  .image-actions {
    position: absolute;
    bottom: -1rem;
    right: 0.5rem;
    .button-label {
      margin-left: 0.25rem;
    }
  }

  .is-loading {
    position: relative;
    opacity: 0.5;
    pointer-events: none;
    &:after {
      position: absolute;
      top: calc(50% - 2.5em);
      left: calc(50% - 2.5em);
      width: 5em;
      height: 5em;
      border: 4px solid;
      border-right-color: transparent;
      border-top-color: transparent;
    }
  }
}
</style>
